import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#5a4579] text-gray-400 py-12 border-t border-white/10" data-id="element-159">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-161">
            <div className="mb-8 md:mb-0 text-center md:text-left" data-id="element-162">
              <img src="https://cdn.magicpatterns.com/uploads/f1DkwGDrQwXrFegqwf8No3/1.png" alt="Inkova LLC Logo" className="h-12 w-auto object-contain rounded-md opacity-80 hover:opacity-100 transition-all duration-300 mx-auto md:mx-0 mb-4" data-id="element-163" />
              <p className="text-inkova-accent font-bold tracking-[0.2em] uppercase text-sm" data-id="element-164">
                Ver · Creer · Crear
              </p>
            </div>

            <div className="text-center md:text-right text-sm font-light space-y-2" data-id="element-165">
              <p className="flex items-center justify-center md:justify-end gap-2" data-id="element-166">
                <span className="text-inkova-accent" data-id="element-167">📱</span> WhatsApp: +1
                (786) 303‑7695
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2" data-id="element-168">
                <span className="text-inkova-accent" data-id="element-169">📧</span>{' '}
                info@inkovacreation.com
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2" data-id="element-170">
                <span className="text-inkova-accent" data-id="element-171">📲</span> @inkovacreation
              </p>
            </div>
          </div>

          <div className="text-center mb-8 pb-8 border-b border-white/10" data-id="element-172">
            <p className="text-lg text-gray-300 italic font-serif" data-id="element-173">
              Donde las ideas se escriben, toman forma y se convierten en algo
              real.
            </p>
          </div>

          <div className="text-center text-xs text-gray-500 mb-8 max-w-4xl mx-auto leading-relaxed" data-id="element-174">
            Inkova LLC no es un despacho de abogados. No ofrecemos asesoramiento
            legal. Coordinamos y acompañamos el proceso de registro y estructura
            de tu empresa.
          </div>

          <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8" data-id="element-175">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white text-sm font-light transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-176">
              Política de Privacidad
            </button>
            <span className="hidden sm:inline text-gray-600" data-id="element-177">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white text-sm font-light transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-white" data-id="element-178">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-179">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-180">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-181">
              <div className="flex justify-between items-center p-6 border-b border-gray-100" data-id="element-182">
                <h3 className="text-xl font-serif text-inkova-primary font-bold" data-id="element-183">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-gray-700 transition-colors p-1" aria-label="Cerrar" data-id="element-184">
                  <X className="w-5 h-5" data-id="element-185" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto max-h-[60vh] prose prose-sm text-gray-700 font-sans" data-id="element-186">
                {activeModal === 'privacy' ? <>
                    <p className="mb-4" data-id="element-187">
                      <strong data-id="element-188">Última actualización:</strong> Abril 2026
                    </p>
                    <p className="mb-4" data-id="element-189">
                      En Inkova LLC ("nosotros", "nuestro"), respetamos tu
                      privacidad y nos comprometemos a proteger la información
                      personal que compartes con nosotros.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-190">
                      1. Información que recopilamos
                    </h4>
                    <p className="mb-4" data-id="element-191">
                      Recopilamos información que nos proporcionas directamente,
                      como tu nombre, correo electrónico, número de teléfono y
                      detalles sobre tu negocio cuando nos contactas o reservas
                      una sesión estratégica.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-192">
                      2. Uso de la información
                    </h4>
                    <p className="mb-4" data-id="element-193">
                      Utilizamos tu información para: comunicarnos contigo sobre
                      nuestros servicios, procesar tus solicitudes, mejorar
                      nuestros servicios y enviarte información relevante sobre
                      Inkova (con tu consentimiento).
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-194">
                      3. Protección de datos
                    </h4>
                    <p className="mb-4" data-id="element-195">
                      Implementamos medidas de seguridad razonables para
                      proteger tu información personal contra acceso no
                      autorizado, alteración o destrucción.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-196">
                      4. Compartir información
                    </h4>
                    <p className="mb-4" data-id="element-197">
                      No vendemos, intercambiamos ni transferimos tu información
                      personal a terceros sin tu consentimiento, excepto cuando
                      sea necesario para cumplir con la ley.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-198">
                      5. Contacto
                    </h4>
                    <p className="mb-4" data-id="element-199">
                      Si tienes preguntas sobre esta política, contáctanos en:{' '}
                      <strong data-id="element-200">(786) 303-7695</strong> o visita{' '}
                      <strong data-id="element-201">inkovacreation.com</strong>.
                    </p>
                  </> : <>
                    <p className="mb-4" data-id="element-202">
                      <strong data-id="element-203">Última actualización:</strong> Abril 2026
                    </p>
                    <p className="mb-4" data-id="element-204">
                      Al utilizar los servicios de Inkova LLC, aceptas los
                      siguientes términos y condiciones. Por favor, léelos
                      cuidadosamente.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-205">
                      1. Servicios
                    </h4>
                    <p className="mb-4" data-id="element-206">
                      Inkova LLC ofrece servicios de consultoría empresarial,
                      creación de empresas (LLC), identidad corporativa y
                      presencia digital. Los servicios específicos y sus
                      alcances se definen en cada plan contratado.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-207">
                      2. Pagos y reembolsos
                    </h4>
                    <p className="mb-4" data-id="element-208">
                      Los pagos deben realizarse según los términos acordados
                      para cada plan. Los fees estatales incluidos en los planes
                      no son reembolsables una vez procesados ante las entidades
                      gubernamentales correspondientes.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-209">
                      3. Responsabilidad del cliente
                    </h4>
                    <p className="mb-4" data-id="element-210">
                      El cliente es responsable de proporcionar información
                      veraz y completa para el registro de su empresa. Inkova
                      LLC no se hace responsable por información incorrecta
                      proporcionada por el cliente.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-211">
                      4. Limitación de responsabilidad
                    </h4>
                    <p className="mb-4" data-id="element-212">
                      Inkova LLC no ofrece asesoría fiscal ni legal.
                      Recomendamos consultar con un profesional calificado para
                      asuntos fiscales y legales específicos. Nuestros servicios
                      son de consultoría empresarial y creación de estructura.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-213">
                      5. Propiedad intelectual
                    </h4>
                    <p className="mb-4" data-id="element-214">
                      Todo el contenido, diseños y materiales creados por Inkova
                      LLC para el cliente se transfieren al cliente una vez
                      completado el pago total del servicio contratado.
                    </p>
                    <h4 className="font-bold text-inkova-primary mt-6 mb-3" data-id="element-215">
                      6. Contacto
                    </h4>
                    <p className="mb-4" data-id="element-216">
                      Para cualquier consulta sobre estos términos:{' '}
                      <strong data-id="element-217">(786) 303-7695</strong> |{' '}
                      <strong data-id="element-218">inkovacreation.com</strong>
                    </p>
                  </>}
              </div>

              <div className="p-4 border-t border-gray-100 flex justify-end" data-id="element-219">
                <button onClick={() => setActiveModal(null)} className="px-6 py-2.5 rounded-full bg-inkova-primary text-white font-medium text-sm hover:bg-inkova-dark transition-colors" data-id="element-220">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}